import React, { useState, memo } from "react";

// icons
import { MdOutlineMarkEmailRead } from "react-icons/md";
import { FaMobileScreenButton } from "react-icons/fa6";
import { BiMessageEdit } from "react-icons/bi";
import { SlEnvolopeLetter } from "react-icons/sl";
import { IoIosSend } from "react-icons/io";
import { FaUserCheck } from "react-icons/fa";

import { useTranslation } from "react-i18next";
import { Fade } from "react-awesome-reveal";
import { useDispatch, useSelector } from "react-redux";
import { SendContactUsThunk } from "../../RTK/Thunk/SendContactUsThunk";

const ContactInput = ({
	label,
	icon: Icon,
	name,
	value,
	placeholder,
	onChange,
	type = "text",
}) => (
	<div className='md:mb-5 mb-4'>
		<label
			htmlFor={name}
			className='text-lg text-second_color font-normal mb-1'>
			{label}
		</label>
		<div className='flex justify-start items-center gap-2 w-full border-[1px] border-slate-200 hover:border-semi_second_color custom-transition rounded-md px-2 py-3'>
			<span>
				<Icon className='text-slate-300 text-lg' />
			</span>
			<input
				className='w-full text-md font-normal border-none focus:border-none outline-none'
				type={type}
				name={name}
				value={value}
				placeholder={placeholder}
				onChange={onChange}
			/>
		</div>
	</div>
);

const ContactUsForm = memo(() => {
	const dispatch = useDispatch();
	const { message, reload } = useSelector((state) => state.ContactUsReducer);
	const { t, i18n } = useTranslation();
	const [contactInfo, setContactInfo] = useState({
		name: "",
		email: "",
		phone: "",
		title: "",
		message: "",
	});

	const handleOnChange = (e) => {
		const { name, value } = e.target;
		setContactInfo((prevState) => ({ ...prevState, [name]: value }));
	};

	const resetData = () =>
		setContactInfo({ name: "", email: "", phone: "", title: "", message: "" });

	const sendMessage = () => {
		dispatch(SendContactUsThunk(contactInfo));
		if (reload) resetData();
	};

	return (
		<section>
			<ContactInput
				label={t("user name")}
				icon={FaUserCheck}
				name='name'
				value={contactInfo.name}
				placeholder={t("user name placeholder")}
				onChange={handleOnChange}
			/>
			<ContactInput
				label={t("email")}
				icon={MdOutlineMarkEmailRead}
				name='email'
				type='email'
				value={contactInfo.email}
				placeholder={t("email placeholder")}
				onChange={handleOnChange}
			/>
			<ContactInput
				label={t("phone number")}
				icon={FaMobileScreenButton}
				name='phone'
				value={contactInfo.phone}
				placeholder={t("phone placeholder")}
				onChange={handleOnChange}
			/>
			<ContactInput
				label={t("message subject")}
				icon={BiMessageEdit}
				name='title'
				value={contactInfo.title}
				placeholder={t("message subject placeholder")}
				onChange={handleOnChange}
			/>

			<div className='md:mb-5 mb-4'>
				<label
					htmlFor='message'
					className='text-lg text-second_color font-normal mb-1'>
					{t("message content")}
				</label>
				<div className='flex justify-start items-start gap-2 w-full border-[1px] border-slate-200 hover:border-semi_second_color custom-transition rounded-md px-2 py-3'>
					<span>
						<SlEnvolopeLetter className='text-slate-300 text-lg' />
					</span>
					<textarea
						className='w-full resize-none md:h-40 h-32 text-md font-normal border-none focus:border-none outline-none'
						name='message'
						value={contactInfo.message}
						placeholder={t("message content placeholder")}
						onChange={handleOnChange}
					/>
				</div>
			</div>

			<div className='w-full m-auto z-10 relative'>
				<Fade
					direction={i18n.language === "ar" ? "right" : "left"}
					triggerOnce={true}>
					<button
						className={`${
							i18n.language === "en" ? "default-btn-ltr" : "default-btn-rtl"
						} default-btn`}
						onClick={sendMessage}>
						{t("send message")}
						<IoIosSend className={i18n.language === "ar" ? "rtl" : "ltr"} />
						<span></span>
					</button>
					{message && <div className='text-md text-green-500'>{message}</div>}
				</Fade>
			</div>
		</section>
	);
});

export default ContactUsForm;
